import { render, staticRenderFns } from "./errorPage403.vue?vue&type=template&id=466b1a71&scoped=true"
import script from "./errorPage403.vue?vue&type=script&lang=js"
export * from "./errorPage403.vue?vue&type=script&lang=js"
import style0 from "./errorPage403.vue?vue&type=style&index=0&id=466b1a71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b1a71",
  null
  
)

export default component.exports